import { useCallback, useMemo } from 'react';
import { emptyFunc, getSelectorOption } from './utils';
import { ComputedParams, ComputedResult } from './types';
import { useIntl, getLocale } from 'umi';

export default function useComputed(options: ComputedParams): ComputedResult {
  const {
    keywords,

    normalHasMore,
    setNormalHasMore,
    normalPage,
    setNormalPage,
    normalCompanies,
    setNormalCompanies,

    searchedHasMore,
    setSearchedHasMore,
    searchedPage,
    setSearchedPage,
    searchedCompanies,
    setSearchedCompanies,

    selectedCompanies,
  } = options || {};

  const { formatMessage } = useIntl();
  const locale = getLocale();

  const hasMore = useMemo(() => {
    return keywords ? searchedHasMore : normalHasMore;
  }, [keywords, normalHasMore, searchedHasMore]);
  const setHasMore = useMemo(() => {
    const setter = keywords ? setSearchedHasMore : setNormalHasMore;
    return setter instanceof Function ? setter : emptyFunc;
  }, [keywords, setNormalHasMore, setSearchedHasMore]);

  const page = useMemo(() => {
    const result = keywords ? searchedPage : normalPage;
    return Number.isNaN(result) ? 1 : result;
  }, [keywords, normalPage, searchedPage]);
  const setPage = useMemo(() => {
    const setter = keywords ? setSearchedPage : setNormalPage;
    return setter instanceof Function ? setter : emptyFunc;
  }, [keywords, setNormalPage, setSearchedPage]);

  const companies = useMemo(() => {
    const values = keywords ? searchedCompanies : normalCompanies;
    return Array.isArray(values) ? values : [];
  }, [keywords, normalCompanies, searchedCompanies]);
  const setCompanies = useMemo(() => {
    const setter = keywords ? setSearchedCompanies : setNormalCompanies;
    return setter instanceof Function ? setter : emptyFunc;
  }, [keywords, setNormalCompanies, setSearchedCompanies]);

  const companyOptions = useMemo(() => companies.map(getSelectorOption), [companies]);

  const isClearable = useMemo(() => {
    return selectedCompanies?.length > 0 && (selectedCompanies?.length !== companies.length);
  }, [selectedCompanies, companies]);

  const buttonLabel = useMemo(() => {
    const selectedCompaniesCount = selectedCompanies?.length || 0;
    const companiesCount = companies?.length || 0;
    let result = '';
    if (!selectedCompaniesCount || (keywords === '' && (selectedCompaniesCount > 1 && selectedCompaniesCount === companiesCount))) { // 没选择公司 或者 全选公司(包含 非搜索状态 和 搜索状态)
      result = formatMessage({id: 'dbi_all'});
    } else if (selectedCompaniesCount < 3) { // 选择公司数量小于3个
      result = selectedCompanies.join(', ');
    } else { // 选择公司数量 大于 3 且 小于 全部公司(区分 非搜索状态 和 搜索状态)
      result = String(selectedCompaniesCount);
    }
    return result
    // return `Company ${result}`;
  }, [companies, selectedCompanies, locale]);

  const getHasMoreSetter = useCallback((keywords: string) => {
    const setter = keywords ? setSearchedHasMore : setNormalHasMore;
    return setter instanceof Function ? setter : emptyFunc;
  }, [setNormalHasMore, setSearchedHasMore]);

  const getCompaniesSetter = useCallback((keywords: string) => {
    const setter = keywords ? setSearchedCompanies : setNormalCompanies;
    return setter instanceof Function ? setter : emptyFunc;
  }, [setNormalCompanies, setSearchedCompanies]);

  return {
    hasMore,
    setHasMore,

    page,
    setPage,

    companies,
    setCompanies,

    getHasMoreSetter,
    getCompaniesSetter,

    isClearable,
    companyOptions,
    buttonLabel,
  };
}
